// extracted by mini-css-extract-plugin
export default {"main":"_8481eaead0","tit":"_29a0854c5f","maintitle":"ca87185571","ylw":"_296ac3622c","white":"_4473d19571","mv_title":"_5febb5cef6","mv_nc":"f89521866f","mv_in":"d4a74421d2"};